/* src/app/front-layout/common/footer/footer.component.css */
/*# sourceMappingURL=footer.component.css.map */
